// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"88800beb","353":"81b75d6b"}[chunkId] + ".js";
};